export default __webpack_public_path__ + "static/media/Name.592f5cdf.svg";